import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/:operator/:id(\\d+)/pemandu',
    name: 'pemandu',
    component: () => lazyLoadView(import('@views/admin/pemandu/List.vue')),
    meta: {
      title: 'Daftar Pemandu',
    },
  },
  {
    path: '/:operator/:id(\\d+)/pemandu/:pemandu_id(\\d+)',
    name: 'pemandu-detil',
    component: () => lazyLoadView(import('@views/admin/pemandu/Detail.vue')),
    meta: {
      title: 'Detail Pemandu',
    },
  },
];
